import { Component } from '@angular/core';
import { MessagesGeneral, MessagesStatus, MessagesTitles } from 'app/models/messages';
import { LoginService } from 'app/services/login/login.service'; 

@Component({
  selector: 'app-kpis',
  templateUrl: './kpis.component.html',
  styleUrls: ['./kpis.component.scss'],
  providers:[MessagesTitles, MessagesGeneral, MessagesStatus]
})
export class KpisComponent{

  constructor(
    private loginService: LoginService,
  ){

  }

  clickGuard() {
    this.loginService.clickGuard = true;
  }
  ExportTOExcel() {
   
  }
}